import { useCallback, useState, useEffect } from "react";
import API from "../../../services/api";
import { useCurrentUser } from "../../../services/auth";

export function useGetContentList() {
  const { data } = useCurrentUser();
  const isLoggin = data?.loggedIn;
  const [contentList, setContentList] = useState(null);

  const getContentList = useCallback(async () => {
    const response = await API.get(`getFoldersByParent?parentID=0`);

    setContentList(response.data.data.sort((a, b) => b.id - a.id));
  }, []);

  useEffect(() => {
    if (isLoggin) {
      getContentList();
    }
  }, [isLoggin]);

  return { contentList, getContentList };
}
